import {useAppSelector} from '../redux/hooks'
import {TMenuAccess, appSelector} from '../redux/slices/appSlices'

type TRoleAccess = Pick<
  TMenuAccess,
  'read' | 'approve' | 'attachment' | 'create' | 'delete' | 'export' | 'update'
>

export const useRoleAccess = (): TRoleAccess => {
  const {selectedMenu: child, selectedMenuParent: parent} = useAppSelector(appSelector)

  if (child?.parent_id == null) {
    return {
      approve: parent?.approve ?? false,
      attachment: parent?.attachment ?? false,
      create: parent?.create ?? false,
      delete: parent?.delete ?? false,
      export: parent?.export ?? false,
      read: parent?.read ?? false,
      update: parent?.update ?? false,
    }
  }

  return {
    approve: child?.approve ?? false,
    attachment: child?.attachment ?? false,
    create: child?.create ?? false,
    delete: child?.delete ?? false,
    export: child?.export ?? false,
    read: child?.read ?? false,
    update: child?.update ?? false,
  }
}
